<template>
  <div
    class="avabgimg tc-avatar"
    :style="`backgroundImage: url(${srcPic});
  backgroundSize:${bgstatus ? 'contain' : 'cover'};`"
  ></div>
</template>
<script>
export default {
  props: {
    srcPic: {
      type: String,
      default: `${process.env.VUE_APP_PICTURL}/csimg/141920220200218183122.jpge`
    },
  },
  data () {
    return {
      bgstatus: false
    }
  },
  watch: {
    srcPic () {
      this.getbgstatus(this.srcPic)
    }
  },
  mounted () {
    this.getbgstatus(this.srcPic)
  },
  methods: {
    getbgstatus (url) {
      let img = new Image()
      img.src = url
      img.onload = () => {
        if (img.width / img.height > 2) this.bgstatus = true
        else this.bgstatus = false
      }
    }
  }
}
</script>
<style lang="less">
.avabgimg {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
}
</style>